export default {
  backgroundColor: Styles.color.grey.ten,
  bannerBackgroundColor: '',
  clearButtonBackgroundColor: Styles.color.white,
  tabBackground: Styles.color.grey.ten,
};
